export const defaultNS = 'common'
export const supportedLngs = ['sv', 'en', 'fi', 'no', 'da']
export default {
	supportedLngs,
	fallbackLng: 'sv',
	defaultNS,
	ns: [defaultNS],
}
